// Escapes a string so it can be inserted into a regular expression
// from MDN:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters
export const escapeRegex = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

// Convert a search entry into a RegExp, such as for typeahead search. If
// nullable is specified, and its a 'noop' search, then this returns null
export const searchToRegex = (term, nullable = false) => {
  let escaped = escapeRegex(term);
  escaped = escaped.replace(/^\s+/, '').replace(/\s+$/, ''); // Trim

  if (nullable && escaped === '') {
    return null; // Empty search, return null
  }

  escaped = escaped.replace(/\s+/, '\\s+'); // Space expands
  return new RegExp(escaped, 'i'); // Case insensitive
};
